module.exports = __webpack_public_path__ + "static/img/icon_alipay@2x.37541d7c.png";